module.exports = __webpack_public_path__ + "static/img/《客户告知书》20260319-图片-0.5fbe0d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/《客户告知书》20260319-图片-0.jpg
// module id = SCAL
// module chunks = 1